let BG = "rgb(235, 228, 216)";
let colors = [
  "rgb(59, 43, 32)",
  "rgb(209, 42, 47)",
  "rgb(219, 79, 84)",
  "rgb(252, 210, 101)",
  "rgb(124, 169, 191)",
  "rgb(18, 26, 51)",
  "rgb(230, 125, 50)",
  "rgb(252, 188, 25)",
  "rgb(49, 95, 140)",
  "rgb(101, 87, 76)",
  "rgb(189, 177, 164)",
  "rgb(247, 177, 161)",
  // "rgb(183, 217, 206)",
  "rgb(41, 166, 145)",
  // "rgb(241, 222, 177)",
  "rgb(225, 133, 132)",
  "rgb(145, 129, 115)",
  "rgb(107, 117, 136)",
  "rgb(231, 153, 95)",
  "rgb(143, 106, 39)",
  "rgb(113, 66, 54)",
  // "rgb(246, 216, 140)",
  "rgb(41, 59, 95)",
  "rgb(171, 72, 85)",
  "rgb(192, 143, 32)",
];
const _locked = [];
export default class COLORS {
  static get BG() {
    return BG;
  }
  static colorAt(i) {
    return colors[i % colors.length];
  }
  static lock(id) {
    _locked.push(id);
  }
  static get length() {
    return colors.length;
  }
}
